export class IntegrationVariableStruct {
    public idVariableType: number;
    public variableTypeName: string;
    public variableToLife: string;
    public variableIntegration: string;
    public idHealthUnitRelation: number;
}